<template>
  <div class="scheduling-form">
      <div :class="schedulingFormClass" :key="componentKey">
          <event-scheduling-form v-if="isEventForm"></event-scheduling-form>
          <service-scheduling-form v-else></service-scheduling-form>
          <customer-info-step></customer-info-step>
          <div :class="confirmationStepClass"><div class="step-body">
              <div class="row">
                  <div class="col-lg-1"><h4 class="step-num">3</h4></div>
                  <div class="col-lg-11">
                      <div class="step-box">
                          <h4 class="step-title">Confirmation</h4>
                          <div v-if="confirmed">
                              <confirmation-message :address="getAddress"></confirmation-message>
                          </div>
                      </div>
                  </div>
              </div>
          </div></div>
      </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import EventSchedulingForm from './schedulingforms/EventSchedulingForm';
  import ServiceSchedulingForm from './schedulingforms/ServiceSchedulingForm';
  import CustomerInfoStep from './schedulingforms/CustomerInfoStep';
  import ConfirmationMessage from './schedulingforms/ConfirmationMessage';
  import formMixin from '../mixins/formMixin';
  import schedulingMixin from '../mixins/schedulingMixin';

  export default {
    mixins: [formMixin,schedulingMixin],
    data() {
      return {
        errors: [],
        height: '',
      };
    },
    computed: {
      ...mapGetters({
        formErrors: 'fieldsWithErrors',
        userInput: 'response',
      }),
      ...mapGetters('form', [
        'fields',
        'redirect',
        'inline_title',
        'inline_message'
      ]),
      ...mapState('form', { form: 'form', formId: 'formId', confirmed: 'confirmed', cardLoaded: 'cardLoaded' }),
      ...mapState('scheduling', {
          step: 'step',
          details: 'bookingDetails', 
          componentKey: 'componentKey',
          eventLocation: 'eventLocation'
      }),
      isEventForm() {
        return this.form.integrationFormType == 'event';
      },
      schedulingFormClass() {
          return {
              "event-scheduling-form": this.isEventForm,
              "service-scheduling-form": !this.isEventForm
          };
      },
      confirmationStepClass() {
          return {
              "scheduling-service-form-step" : true,
              "step" : true,
              "confirmation-step": true,
              "open": this.confirmed
          }
      },
      getAddress() {
          if (this.details.location.address) {
              return this.details.location.address;
          } else if (this.eventLocation && this.eventLocation.address) {
              return this.eventLocation.address;
          } else {
              return '';
          }
      }
    },
    components: {
      EventSchedulingForm,
      ServiceSchedulingForm,
      CustomerInfoStep,
      ConfirmationMessage
    }
  };
</script>

<style>
    #app {
        font-family: SFProDisplay,'Avenir', Helvetica, Arial, sans-serif;
        padding-bottom:25px;
    }
    a {
        color:#006dd0;
    }
    .disabled {
        cursor: not-allowed;
    }
    .step {
        margin: 12px 0;
        padding: 32px;
        border-radius: 5px;
        border: solid 1px #e6e6e6;
        background-color: #ffffff;
        padding: 0;
        color: rgba(0,0,0,.85);
        font-size: 14px;
        font-variant: tabular-nums;
        line-height: 1.5715;
        list-style: none;
        font-feature-settings: "tnum";
        position: relative;
    }
    .step-fields-list-box {
        margin: 20px 0 0;
        border-radius: 5px;
        border: solid 1px #e6e6e6;
        background-color: #ffffff;
    }
    .step-field div.step-fields-list-box-item, .step-field tr.step-fields-list-box-item td {
        padding:14px 12px;
        border-bottom: 1px solid #e6e6e6;
        transition: background .3s;
    }
    .step-field div.step-fields-list-box-item:hover, .step-field tr.step-fields-list-box-item:hover td,
    .step-field div.step-fields-list-box-item .selected, .step-field div.step-fields-list-box-item.selected,
    .step-field tr.step-fields-list-box-item.selected,
    .grey-background {
        background: #fafafa;
    }
    .step.open {
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    }
    .step > .step-body {
        padding: 24px;
    }
    .step-num {
        background-color: rgb(0, 109, 208);
        vertical-align: middle;
        width: 39px;
        height: 39px;
        padding: 0;
        font-size: 20px;
        box-sizing: border-box;
        margin: 0;
        margin-left:auto;
        margin-right:auto;
        font-variant: tabular-nums;
        list-style: none;
        font-feature-settings: "tnum";
        position: relative;
        overflow: hidden;
        color: #e5f0fa;
        white-space: nowrap;
        font-stretch: normal;
        font-style: normal;
        font-weight: 600;
        text-align: center;
        line-height: 39px;
        letter-spacing: normal;
        border-radius: 50%;
    }
    .step-title {
        margin: 7px 0 24px;
        font-size: 20px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.2;
        letter-spacing: normal;
        text-align: left;
        color: #24282f;
    }
    .booking-details {
        margin-bottom:24px;
        clear:both;
    }
    .step-fields > .form-group {
        padding-left: 0;
        padding-right: 0;
    }
    .btn-step-select {
        appearance:button;
        color: var(--theme-ui-colors-cta-primary,#006DD0);
        box-sizing: border-box;
        margin: 0px;
        min-width: 0px;
        text-align: center;
        padding: 8px 20px;
        height: 48px;
        font-size: 14px;
        display: inline-flex;
        -moz-box-align: center;
        align-items: center;
        -moz-box-pack: center;
        justify-content: center;
        line-height: 1;
        font-weight: 600;
        border-radius: 5px;
        cursor: pointer;
        outline: currentcolor none medium;
        transition: color 0.2s ease-out 0s, border-color 0.2s ease-out 0s, background-color 0.2s ease-out 0s;
        text-decoration: none;
        white-space: nowrap;
        background-color: transparent;
        border-style: solid;
        border-width: 1px;
        border-image: none 100% / 1 / 0 stretch;
        border-color: var(--theme-ui-colors-cta-primary,#006DD0);
    }
    .btn-step-select:hover, .selected .btn-step-select {
        background:#DFF0FF;
    }
    .step-field-heading {
        height: 24px;
        line-height:16px;
        line-height: 1.19;
        letter-spacing: normal;
        text-align: left;
        color: #24282f;
        margin-bottom:20px;
    }
    .step-field-heading > span {
        display: inline-block;
        padding-right:5px;
    }
    .step-field-heading > span.back {
        cursor: pointer;
    }
    .step-field-heading-text {
        font-size: 16px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
    }
    .scheduling-form .btn.madform-submit {
        background-color: #016dd0;
        border-color: #016dd0;
    }
    .step-box {
        padding-right:10px;
    }
    .schedule-step .booking-details {
        padding:24px;
        margin-bottom:20px;
    }

    @media only screen and (max-width: 770px) {
        body .button-row {
            display:flex;
            align-items: stretch;
        }
        body .button-column .btn-step-select, body .selected .button-column .btn-step-select, body .button-column .btn-step-select:hover {
            font-size:0;
            border:0;
            position:relative;
            text-align:left;
            display: block;
            padding: 0;
            margin: 0;
            background: transparent url("../assets/keyboard_arrow_right-24px.svg") no-repeat center center;
            width: 100%;
            min-width:24px;
            min-height:24px;
            opacity:.5
        }
        #app > .container {
            padding-left: 0;
            padding-right: 0;
        }
        .step-field-heading {
            margin-bottom:16px;
        }
        .schedule-step.open .booking-details {
             display:none;
        }
        .schedule-step .booking-details {
            padding: 32px 0 16px;
        }
        .schedule-step .booking-details > h5, .booking-details-left {
            padding-left: 16px;
            padding-right: 16px;
        }
        .booking-details-left {
            width:100%;
            flex-basis: auto;
            border-bottom:1px solid #dee2e6;
            padding-bottom:16px;
        }
        .booking-details-left > div {
            display: block;
        }
        body .booking-details-left .item-cell {
            width: 100%;
            padding-bottom:.25em;
        }
        body .booking-details-left .item-name {
            padding-bottom: .25em;
        }
        body .booking-details-left .last-cell {
            width: 100%;
            padding: 0;
        }
        .booking-details-right {
            padding-top: 16px;
        }
        .booking-details-right > ul {
            margin-bottom: 0;
        }
        .booking-details-right.border-left {
            border: 0!important;
        }
        .booking-details-left .item-cell {
            width:100%;
            line-height: 1.43;
        }
        .booking-details-left .price-duration { text-align: left }
        .booking-details-left .price-duration > div {
            display: inline-block;
            padding-right: .5em;
            text-align: left;
        }
        .step > .step-body {
            padding:16px;
        }
        .step > .step-body > .row {
            margin-left: 0;
            margin-right: 0;
        }
        .step > .step-body > .row > .col-lg-1, .step > .step-body > .row >  .col-lg-11,
        .step-schedulingDateAndTime > .step-body > .row > .col-lg-5, .step-schedulingDateAndTime > .step-body > .row >  .col-lg-7 {
            padding-left:0;
            padding-right:0;
        }
        .step-title { text-align: center; margin-bottom: 35px; }
        .step-box {
            padding-top: 12px;
            padding-right: 0;
        }
        .step-box .row {
            margin-left:0;
            margin-right:0;
        }
        .step-box .col-lg-12, .customer-fields .form-group {
            padding-left: 0;
            padding-right: 0;
        }
        .spinner-border {
            margin: auto;
            display: block;
        }

        .service-row, .event-row {
            display: flex;
            gap: 0;
        }
        .service-row .item-cell, .event-row .item-cell {
            width: 62%
        }
        .service-row .last-cell, .event-row .last-cell {
            width: 36%;
            padding-left: 2%;
        }
        .service-row .image-cell, .event-row .image-cell {
            display: none
        }
        .service-row .last-cell-price-duration, .event-row .last-cell-price-duration {
            width:100%;
            margin: 0;
            display:flex;
        }
        .last-cell-price-duration .price-duration {
            float: none;
            min-width:70%;
        }
        .last-cell-price-duration .select {
            float:none;
            min-width:30%;
        }
    }
</style>
